<script>
  import Button from "@sourcewhale/shared/svelte-design-system/components/atoms/Button.svelte";
  import { userStore } from "@sourcewhale/shared/src/svelte/api-stores/user-store.js";
  import { getDemoLink } from "../../../../api/requests.js";
  import { requestAccess } from "../../../../api/request-access.js";

  let {
    kind = "upgrade",
    selectedModule,
    size = "large",
    text = "Speak to sales",
  } = $props();

  const handleBookDemo = async () => {
    const currentUser = $userStore;
    if ($userStore.accountManager) {
      const response = await requestAccess("Full Access to Sourcewhale");
      if (response.url) window.open(response.url);
    } else {
      const body = {
        email: currentUser.regularizedEmail,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        isPLG: true,
        selectedModule,
        teamId: currentUser.teamId,
      };
      const response = await getDemoLink(body);
      window.open(response.url);
    }
  };
</script>

<Button {kind} {size} onclick={handleBookDemo}>{text}</Button>
